.compactPill {
    --pill-border-radius: var(--compact-pill-border-radius);
    --pill-padding: var(--compact-pill-padding);
}
